module.exports = __webpack_public_path__ + "img/flag-PA.49adac91.png";